import { motion } from "framer-motion";
import { useState } from "react";
import DestinationCostModel from "../../model/DestinationCostModel";
import BookingModel from "../../model/BookingModel";
import fareModel from "../../model/FareModel";

export default function Details({ formData, setFormData, isModalOpen, setIsModalOpen }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showModalTooltip, setShowModalTooltip] = useState(false);
  
  const isMinimumKMApplied = DestinationCostModel.isMinimumKMApplied;
  const actualDistance = DestinationCostModel.actualCalculatedDistance || 0;
  const minimumKM = fareModel.minimumKM || 0;
  return (
    <div className="booking-step-details">
      <div className="heading">Select Luggage Count Details</div>
      <div className="details-box">
        <div className="detail-item">
          <span>Passenger Name</span> <p>{formData.passengerName}</p>
        </div>
        <div className="detail-item">
          <span>Number of Adults</span> <p>{formData.passengerCount}</p>
        </div>
        <div className="detail-item">
          <span>Additional Distance</span> <p>{formData.adjustDistance || 0} Km.</p>
        </div>
        <div className="detail-item">
          <span>Destination</span> <p>{formData.destination}</p>
        </div>
        <div className="detail-item">
          <span>Number of Children</span> <p>{formData.kidsCount}</p>
        </div>
        <div className="detail-item">
          <span>Waiting Time</span> <p>{formData.waitMinute || 0} Min.</p>
        </div>
        <div className="detail-item">
          <span>Total Distance</span> <p>{Number(formData.tripDistance || 0) + Number(formData.adjustDistance || 0)} Km.</p>
        </div>
        <div className="detail-item">
          <span>Baggage</span>
          <p>
            Large ({formData.largeBag}), Medium ({formData.mediumBag}), Cabin ({formData.cabinBag})
          </p>
        </div>
        <div className="detail-item">
          <span>Total Cost</span> 
          <p style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '5px 0 0', width: '100%' }}>
            Rs. {Number(BookingModel.totalAmount).toFixed(2)} /-
            {isMinimumKMApplied && (
              <span 
                style={{ position: 'relative', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <i className="fa-solid fa-circle-info" style={{ color: '#ADC045', fontSize: '16px' }}></i>
                {showTooltip && (
                  <div style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    marginBottom: '8px',
                    padding: '8px 12px',
                    backgroundColor: '#333',
                    color: '#fff',
                    borderRadius: '4px',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    zIndex: 1000,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    pointerEvents: 'none'
                  }}>
                    Minimum KM ({minimumKM} KM) applied. Actual distance: {actualDistance.toFixed(1)} KM
                    <div style={{
                      position: 'absolute',
                      bottom: '-4px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '4px solid transparent',
                      borderRight: '4px solid transparent',
                      borderTop: '4px solid #333'
                    }}></div>
                  </div>
                )}
              </span>
            )}
          </p>
        </div>
      </div>
      {isModalOpen && (
        <div className="dmodal-overlay">
          <motion.div
            className="dmodal-content"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            <div className="dmodal-header" >
              <span>Fare Details</span>
              <i className="fa-solid fa-xmark close-btn" onClick={() => setIsModalOpen(false)}></i>
            </div>
            <div className="dmodal-body">
              <div className="fare-item"><span>Base Fare</span> <p>{DestinationCostModel.baseAmount}</p></div>
              {DestinationCostModel.additionalCharge != 0 && (
                <div className="fare-item">
                  <span>Additional Distance Charge</span>
                  <p>{DestinationCostModel.additionalCharge}</p>
                </div>
              )}

              {BookingModel.waitingCharge > 0 && (
                <div className="fare-item">
                  <span>Waiting Time Charge</span>
                  <p>{BookingModel.waitingCharge}</p>
                </div>
              )}

              {BookingModel.highRangeCharge > 0 && (
                <div className="fare-item">
                  <span>Highrange Rate</span>
                  <p>{BookingModel.highRangeCharge}</p>
                </div>
              )}

              {BookingModel.tollCharge > 0 && (
                <div className="fare-item">
                  <span>Toll Charge</span>
                  <p>{BookingModel.tollCharge}</p>
                </div>
              )}

              {BookingModel.peakTimeCharge > 0 && (
                <div className="fare-item">
                  <span>Peak Time Charge</span>
                  <p>{BookingModel.peakTimeCharge}</p>
                </div>
              )}

              <div className="fare-item"><span>Surcharge</span> <p>{BookingModel.surcharge}</p></div>
              <div className="fare-item"><span>G.S.T</span> <p>{parseFloat(BookingModel.cgst) + parseFloat(BookingModel.sgst)}</p></div>
              <div className="fare-item total-cost">
                <span>Total Cost</span> 
                <p style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  {BookingModel.totalAmount}
                  {isMinimumKMApplied && (
                    <span 
                      style={{ position: 'relative', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                      onMouseEnter={() => setShowModalTooltip(true)}
                      onMouseLeave={() => setShowModalTooltip(false)}
                    >
                      <i className="fa-solid fa-circle-info" style={{ color: '#ADC045', fontSize: '16px' }}></i>
                      {showModalTooltip && (
                        <div style={{
                          position: 'absolute',
                          bottom: '100%',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          marginBottom: '8px',
                          padding: '8px 12px',
                          backgroundColor: '#333',
                          color: '#fff',
                          borderRadius: '4px',
                          fontSize: '12px',
                          whiteSpace: 'nowrap',
                          zIndex: 1000,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          pointerEvents: 'none'
                        }}>
                          Minimum KM ({minimumKM} KM) applied. Actual distance: {actualDistance.toFixed(1)} KM
                          <div style={{
                            position: 'absolute',
                            bottom: '-4px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '4px solid transparent',
                            borderRight: '4px solid transparent',
                            borderTop: '4px solid #333'
                          }}></div>
                        </div>
                      )}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}
